import React, { useMemo, useState } from 'react'

import { WithSession } from '../../../session/SessionProvider'
import { WithBackend } from '../../../backend/BackendProvider'
import PremiumOverlay from 'components/premium_membership/PremiumOverlay'
import { SubscriptionType } from 'components/common/types/Subscription'
import { WithAppsignal } from 'components/appsignal/AppsignalProvider'
import { WithFlashMessages } from 'components/flashmessages/FlashMessageProvider'

import ResearchDashboardMetricsGrid from './ResearchDashboardMetricsGrid'
import ResearchDashboardSidebar from './ResearchDashboardSidebar'
import { getResearchDashboardMetrics } from './ResearchDashboardMetrics'

const ResearchDashboard: React.FC = () => {
  const [selectedMetric, setSelectedMetric] = useState<string | null>(null)
  const metricDefinitions = useMemo(() => getResearchDashboardMetrics(), [])

  const handleCardClick = (metricId: string): void => {
    setSelectedMetric(prev => prev === metricId ? null : metricId)
  }

  return (
    <PremiumOverlay activeFor={[SubscriptionType.WAH_RESEARCHER]} showBadge={false}>
      <div className='research-dashboard-shell'>
        <ResearchDashboardSidebar />
        <div className='research-dashboard-container'>
          <ResearchDashboardMetricsGrid
            definitions={metricDefinitions}
            onCardClick={handleCardClick}
            selectedMetric={selectedMetric}
          />
        </div>
      </div>
    </PremiumOverlay>
  )
}

export default WithFlashMessages(WithAppsignal(WithBackend(WithSession(ResearchDashboard))))
